import request from '@/libs/request';

export const GetReplyRuleList = (data = {}) => request('GetReplyRuleList', data); // 查询回复规则列表
export const AddReplyRule = (data = {}) => request('AddReplyRule', data); // 新增规则
export const EditReplyRule = (data = {}) => request('EditReplyRule', data); // 编辑回复规则
export const DelReplyRule = (data = {}) => request('DelReplyRule', data); // 删除回复规则
export const GetReplyRule = (data = {}) => request('GetReplyRule', data); // 查询回复规则详情
export const EditWelcom = (data = {}) => request('EditWelcom', data); // 编辑被关注消息
export const EditDefaultRule = (data = {}) => request('EditDefaultRule', data); // 编辑收到消息回复
export const GetWelcom = (data = {}) => request('GetWelcom', data); // 查询收到消息回复
export const DelWelcom = (data = {}) => request('DelWelcom', data); // 删除收到消息回复

// 消息列表接口
export const GetAppMsgList = (data = {}) => request('GetAppMsgList', data); // 获取消息列表
export const GetUserMsgList = (data = {}) => request('GetUserMsgList', data); // 获取用户消息列表
export const ReplyMsg = (data = {}) => request('ReplyMsg', data); // 回复消息
export const GetCollectMsgList = (data = {}) => request('GetCollectMsgList', data); // 查询收藏消息列表
export const CollectMsg = (data = {}) => request('CollectMsg', data); // 收藏与取消收藏消息
export const QuerNewMsgNum = (data = {}) => request('QuerNewMsgNum', data); // 接收消息提醒
export const ExportMessage = (data = {}) => request('ExportMessage', data); // 导出消息列表
